import {
    Box,
    Container,
    Flex,
    Stack,
    Text,
    useColorModeValue,
} from "@chakra-ui/react";
import { FaMobileAlt } from "react-icons/fa";
import { MdOutgoingMail } from "react-icons/md";

export default function NewFooter() {
    return (
        <Box
            bg={useColorModeValue("gray.50", "gray.900")}
            color={useColorModeValue("gray.700", "gray.200")}
        >
            <Container
                as={Stack}
                maxW={"6xl"}
                py={4}
                direction={{ base: "column", md: "row" }}
                spacing={4}
                justify={{ base: "center", md: "space-between" }}
                align={{ base: "center", md: "center" }}
            >
                <Text>© 2022 Ashish Kohad. All rights reserved</Text>
                <Stack direction={"row"} spacing={6}>
                    <Flex justifyContent="center" alignItems="center">
                        <FaMobileAlt pr="10px" />
                        <span>+91-8668794792</span>
                    </Flex>
                    <Flex justifyContent="center" alignItems="center">
                        <MdOutgoingMail pr="10px" />
                        <span>kohadashish27@gmail.com</span>
                    </Flex>
                </Stack>
            </Container>
        </Box>
    );
}
